import FatcaForm from "./FATCAForm.container";
export default FatcaForm;
